import moment from 'moment'

export const HeroSectionConfig = {
  'biz-about': 'SectionItem',
  commodity: 'SectionItemSecond',
  'commodity-show': 'SectionItemThird'
}

// 活动概览判断是否跨年
export function isCurrentYear(time: number): boolean {
  return moment(time).year() === moment().year()
}
